function IconMail({ size = 41, color = '#909296' }: { size?: number; color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 52 52"
      fill="none"
    >
      <path
        stroke={color}
        d="M46 15.1666C46 12.7734 44.0599 10.8333 41.6667 10.8333H11.3333C8.9401 10.8333 7 12.7734 7 15.1666M46 15.1666V36.8333C46 39.2265 44.0599 41.1666 41.6667 41.1666H11.3333C8.9401 41.1666 7 39.2265 7 36.8333V15.1666M46 15.1666L26.5 28.1666L7 15.1666"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
IconMail.displayName = 'IconMail';

export { IconMail };
